import { render, staticRenderFns } from "./tracky.vue?vue&type=template&id=2fb66838&scoped=true"
import script from "./tracky.vue?vue&type=script&lang=js"
export * from "./tracky.vue?vue&type=script&lang=js"
import style0 from "./tracky.vue?vue&type=style&index=0&id=2fb66838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb66838",
  null
  
)

export default component.exports